<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-3">
        <SearchFilters
          :category-options="categoryOptions"
          :brand-options="brandOptions"
          :type-options="typeOptions"
          :industry-options="industryOptions"
          :size-options="sizeOptions"
          :btu-options="btuOptions"
          :url-builder="urlBuilder"
          v-model:category-filter="categoryFilter"
          v-model:brand-filter="brandFilter"
          v-model:type-filter="typeFilter"
          v-model:industry-filter="industryFilter"
          v-model:size-filter="sizeFilter"
          v-model:btu-filter="btuFilter"
          v-model:online-only-filter="onlineOnlyFilter"
        />
      </div>
      <div class="col-xs-12 col-sm-9">
        <SearchResults
          :models="models"
          @load-more="loadMore"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* global models, categoryOptions, brandOptions, typeOptions, industryOptions, sizeOptions, btuOptions, pageUrl */

import SearchFilters from './components/SearchFilters.vue'
import SearchResults from './components/SearchResults.vue'

export default {
  name: 'ModelSearch',
  components: {
    SearchFilters,
    SearchResults
  },
  data () {
    return {
      allModels: models,
      allBrandOptions: brandOptions,
      allTypeOptions: typeOptions,
      allIndustryOptions: industryOptions,
      allSizeOptions: sizeOptions,
      allBtuOptions: btuOptions,
      models: [],
      categoryOptions: categoryOptions,
      brandOptions: [],
      typeOptions: [],
      industryOptions: [],
      sizeOptions: [],
      btuOptions: [],
      categoryFilter: '',
      brandFilter: [],
      typeFilter: [],
      industryFilter: [],
      sizeFilter: [],
      btuFilter: [],
      onlineOnlyFilter: false,
      pageUrl: pageUrl,
      urlBuilder: '',
      maxToShow: 18,
      pageSize: 18,
      currentlyShowing: 0,
      useLocalStorage: false,
      loadingComplete: false
    }
  },
  created: function () {
    if (typeof localStorage !== 'undefined') {
      this.useLocalStorage = true
    }

    var urlParams = [];
    (window.onpopstate = function () {
      var match
      var pl = /\+/g // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g
      var decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')) }
      var query = window.location.search.substring(1)

      var filters = ['category', 'brands', 'types', 'industries', 'sizes', 'btus', 'online_only']

      while ((match = search.exec(query))) {
        if (filters.indexOf(decode(match[1])) >= 0) {
          urlParams.push({ name: decode(match[1]), value: decodeURIComponent(match[2]) })
        }
      }
    })()

    // if we have urlParams load the data from those, otherwise load from local storage if we have it
    if (urlParams.length) {
      this.categoryFilter = ''
      this.brandFilter = []
      this.typeFilter = []
      this.industryFilter = []
      this.sizeFilter = []
      this.btuFilter = []
      this.onlineOnlyFilter = false

      urlParams.forEach(function (urlParam) {
        var paramValue = parseInt(urlParam.value)
        switch (urlParam.name) {
          case 'category':
            this.categoryFilter = paramValue
            break
          case 'brands':
            this.brandFilter.push(paramValue)
            break
          case 'types':
            this.typeFilter.push(paramValue)
            break
          case 'industries':
            this.industryFilter.push(paramValue)
            break
          case 'sizes':
            this.sizeFilter.push(paramValue)
            break
          case 'btus':
            this.btuFilter.push(paramValue)
            break
          case 'online_only':
            this.onlineOnlyFilter = (paramValue === 1)
            break
        }
      }, this)
    } else {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        this.categoryFilter = (localStorage.getItem('categoryFilter') === null) ? '' : localStorage.getItem('categoryFilter')
        this.brandFilter = (localStorage.getItem('brandFilter') === null) ? [] : JSON.parse(localStorage.getItem('brandFilter'))
        this.typeFilter = (localStorage.getItem('typeFilter') === null) ? [] : JSON.parse(localStorage.getItem('typeFilter'))
        this.industryFilter = (localStorage.getItem('industryFilter') === null) ? [] : JSON.parse(localStorage.getItem('industryFilter'))
        this.sizeFilter = (localStorage.getItem('sizeFilter') === null) ? [] : JSON.parse(localStorage.getItem('sizeFilter'))
        this.btuFilter = (localStorage.getItem('btuFilter') === null) ? [] : JSON.parse(localStorage.getItem('btuFilter'))
        this.onlineOnlyFilter = (localStorage.getItem('onlineOnlyFilter') === null) ? false : (localStorage.getItem('onlineOnlyFilter') === 'true')
      }
    }

    this.buildUrl()
    this.updateFilters()
    this.filterModels()
    this.loadingComplete = true
  },
  watch: {
    categoryFilter: function () {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        localStorage.setItem('categoryFilter', this.categoryFilter)
      }
      if (this.loadingComplete) {
        this.maxToShow = 18
        this.buildUrl()
        this.updateFilters()
        this.filterModels()
      }
    },
    brandFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('brandFilter', JSON.stringify(this.brandFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    typeFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('typeFilter', JSON.stringify(this.typeFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    industryFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('industryFilter', JSON.stringify(this.industryFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    sizeFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('sizeFilter', JSON.stringify(this.sizeFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    btuFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('btuFilter', JSON.stringify(this.btuFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    onlineOnlyFilter: function () {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        localStorage.setItem('onlineOnlyFilter', this.onlineOnlyFilter)
      }
      if (this.loadingComplete) {
        this.maxToShow = 18
        this.buildUrl()
        this.filterModels()
      }
    }
  },
  methods: {
    buildUrl: function () {
      var query = ''
      if (this.categoryFilter !== '') {
        if (query.length) {
          query = query + '&'
        }
        query = query + 'category=' + this.categoryFilter
      }
      if (this.brandFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.brandFilter.map(function (value) {
          return 'brands=' + value
        }).join('&')
      }
      if (this.typeFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.typeFilter.map(function (value) {
          return 'types=' + value
        }).join('&')
      }
      if (this.industryFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.industryFilter.map(function (value) {
          return 'industries=' + value
        }).join('&')
      }
      if (this.sizeFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.sizeFilter.map(function (value) {
          return 'sizes=' + value
        }).join('&')
      }
      if (this.btuFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.btuFilter.map(function (value) {
          return 'btus=' + value
        }).join('&')
      }
      if (this.onlineOnlyFilter === true || this.onlineOnlyFilter === 'true') {
        if (query.length) {
          query = query + '&'
        }
        query = query + 'online_only=1'
      }

      if (query.length) {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0] + '?' + query)
      } else {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0])
      }
      this.urlBuilder = pageUrl + '?' + query
    },
    filterModels: function () {
      this.currentlyShowing = 0
      this.models = []

      for (var i = 0; i < this.allModels.length; i++) {
        var hide = false
        this.currentlyShowing++
        var checkModel = this.allModels[i]

        if (!hide) {
          if (this.categoryFilter !== '') {
            if (!checkModel.category.includes(parseInt(this.categoryFilter))) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.brandFilter.length) {
            var brandMatched = true
            if (this.brandFilter.indexOf(checkModel.brand) < 0) {
              brandMatched = false
            }

            if (!brandMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.typeFilter.length) {
            // if this model matches any of the selected types, show it
            var typeMatched = false
            for (var j = 0; j < this.typeFilter.length; j++) {
              var checkType = parseInt(this.typeFilter[j])
              if (checkModel.type.length) {
                for (var x = 0; x < checkModel.type.length; x++) {
                  var checkModelType = parseInt(checkModel.type[x])
                  if (checkType === checkModelType) {
                    typeMatched = true
                  }
                }
              }
            }

            if (!typeMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.industryFilter.length) {
            var industryMatched = true
            if (this.industryFilter.indexOf(checkModel.industry) < 0) {
              industryMatched = false
            }

            if (!industryMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.sizeFilter.length) {
            // if this model matches any of the selected sizes, show it
            var sizeMatched = false
            for (var k = 0; k < this.sizeFilter.length; k++) {
              var checkSize = parseInt(this.sizeFilter[k])
              if (checkModel.size.length) {
                for (var y = 0; y < checkModel.size.length; y++) {
                  var checkModelSize = parseInt(checkModel.size[y])
                  if (checkSize === checkModelSize) {
                    sizeMatched = true
                  }
                }
              }
            }

            if (!sizeMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.btuFilter.length) {
            var btuMatched = true
            if (this.btuFilter.indexOf(checkModel.btu) < 0) {
              btuMatched = false
            }

            if (!btuMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.onlineOnlyFilter && !checkModel.online_purchase) {
            hide = true
            this.currentlyShowing--
          }
        }

        if (this.currentlyShowing > this.maxToShow) {
          hide = true
        }

        if (!hide) {
          this.models.push(checkModel)
        }
      }
    },
    updateFilters: function () {
      if (this.loadingComplete) {
        // reset the filters when the category filter changes
        this.brandFilter = []
        this.typeFilter = []
        this.industryFilter = []
        this.sizeFilter = []
        this.btuFilter = []
      }

      if (this.categoryFilter !== '') {
        var displayBrandOptions = []
        var displayTypeOptions = []
        var displayIndustryOptions = []
        var displaySizeOptions = []
        var displayBtuOptions = []

        for (var i = 0; i < this.allModels.length; i++) {
          var checkModel = this.allModels[i]

          if (checkModel.category.includes(parseInt(this.categoryFilter))) {
            displayBrandOptions.push(checkModel.brand)
            displayIndustryOptions.push(checkModel.industry)
            displayBtuOptions.push(checkModel.btu)

            checkModel.type.forEach(function (type) {
              displayTypeOptions.push(type)
            })
            checkModel.size.forEach(function (size) {
              displaySizeOptions.push(size)
            })
          }
        }

        var rootObj = this
        rootObj.brandOptions = []
        rootObj.allBrandOptions.forEach(function (brand) {
          if (displayBrandOptions.indexOf(brand.id) >= 0) {
            rootObj.brandOptions.push(brand)
          }
        })
        rootObj.typeOptions = []
        rootObj.allTypeOptions.forEach(function (type) {
          if (displayTypeOptions.indexOf(type.id) >= 0) {
            rootObj.typeOptions.push(type)
          }
        })
        rootObj.industryOptions = []
        rootObj.allIndustryOptions.forEach(function (industry) {
          if (displayIndustryOptions.indexOf(industry.id) >= 0) {
            rootObj.industryOptions.push(industry)
          }
        })
        rootObj.sizeOptions = []
        rootObj.allSizeOptions.forEach(function (size) {
          if (displaySizeOptions.indexOf(size.id) >= 0) {
            rootObj.sizeOptions.push(size)
          }
        })
        rootObj.btuOptions = []
        rootObj.allBtuOptions.forEach(function (btu) {
          if (displayBtuOptions.indexOf(btu.id) >= 0) {
            rootObj.btuOptions.push(btu)
          }
        })
      } else {
        this.brandOptions = this.allBrandOptions
        this.typeOptions = this.allTypeOptions
        this.industryOptions = this.allIndustryOptions
        this.sizeOptions = this.allSizeOptions
        this.btuOptions = this.allBtuOptions
      }
    },
    loadMore: function () {
      this.maxToShow += this.pageSize
      this.filterModels()
    }
  }
}
</script>
